<template>
    <div>
        <center>

            <div class="speak-container">
                <div v-for="speak in speakList" :key=speak.id class="message-line">
                    <!-- <div class="row no-wrap">
                        <div class="user-name"> {{speak.userName}}</div>
                        <div class="speak-date"> {{speak.prettyDate}}</div>
                    </div>
                    <div class="message">
                        {{speak.message}}
                    </div> -->
                    <!-- Вариант компактного дизайна -->
                    <div class='row items-baseline'>
                        <div class="speak-date">{{speak.prettyDate}}</div>
                        <div class="user-name"> {{speak.userName}}:</div>
                        <div class="message q-ml-xs"> {{speak.message}}</div>
                    </div>
                </div>
            </div>

        <!-- форма ввода новой заметки  -->
            <form @submit.prevent="sendMessage">
                <div class="message-container  row no-wrap" >
                    <input class='message-input' v-model=message>
                    <q-btn color="green-8" size=sm icon-right="send" label="ок" class="ok-button" @click='sendMessage' :loading="loading"/>
                </div>
            </form>

        </center>
    </div>
</template>
<script>
/* eslint-disable */
export default {
    name : 'printTerminalFileDialog',
    
    data () {
            return {
                message : '', // cообщение
                loading : false,
            }
    },

    props : {
        file_id : 0,
    },

    created() {
    },

    computed :{
        
        speakList() {
            var list = [];
            if (this.$store.getters.getFileSpeak(this.file_id) != undefined) {
                
                list = this.$store.getters.getFileSpeak(this.file_id);
            }

            var options = {
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            };

            let d = new Date();
            let currentTimeZoneOffset = d.getTimezoneOffset() / 60;

            //нужно дозаполнить список
            list.forEach(item => {
                let date = new Date(item.created_at); // делаем приятную дату
                date.setHours(date.getHours()-currentTimeZoneOffset);
                item.prettyDate = date.toLocaleString("ru", options);

                let user = this.$store.getters.getUserById(item.who); // получили данные юзера
                item.userName = '';
                if (user != undefined) item.userName = user.name +' '+ user.surname;

            });
            return list;
        },

    },

    methods : {
        sendMessage() {
            if (this.message=='') return;
            this.loading = true;
            this.$store.dispatch("saveMessage", {id:this.file_id, message:this.message})
            .then(()=>{
                this.loading = false;
                this.message = '';
            })
            .catch( ()=>{
                this.$admns.showNotify('Ошибка записи сообщения', 'error','Сообщение системы');
                this.loading = false;
            });

        },
    }
}
</script>

<style lang="scss" scoped>
    .speak-container {
        margin-top : 20px;
        width:90%;
        background:white;
        height: auto;
        border:1px solid #d3d3d3;
        text-align: left;
    }
    .message-container {
        background: #d3d3d3;
        width:90%;
        height:40px;

    }
    .message-input {
        width:70%;
        margin: 7px;
        font-family: Arial, Helvetica, sans-serif;
        font-size : 18px;
        float : left;
    }
    .ok-button {
        margin : 3px;
        width  : 20%;
        min-width:80px;
    }
    .user-name {
        font-family: Arial, Helvetica, sans-serif;
        font-size : 13px;
        font-weight: bold;       
        border-bottom: 1px dotted rgb(190, 190, 190);
        white-space: nowrap;
    }
    .speak-date {
        // width : 30%;
        min-width : 100px;
        text-align : left;
        font-size:13px;
        font-weight: bold;
        border-bottom: 1px dotted rgb(190, 190, 190);
    }
    .message {
        font-family: Arial, Helvetica, sans-serif;
        font-size:13px;
        padding: 1px;        
        margin-bottom: 0px;
        color:rgb(83, 83, 83);
        // border-bottom: 1px dotted rgb(190, 190, 190);
    }
    .message-line {
        padding: 8px;
        cursor: default;
        &:hover {
            background : rgb(225, 252, 225);
        }
    }
</style>

